<!-- ═══════ PAGE TOP (title + project/client only) ═══════ -->
<div class="rd-page-top">
<div class="rd-header">
  <div class="rd-header__left">
    <button class="rd-back-btn" [routerLink]="['/project', projectId]" title="Go back">
      <fa-icon [icon]="faChevronLeft"></fa-icon>
    </button>
    <div class="rd-header__title-block">
      <h1 class="rd-header__title">Project Readiness</h1>
      <span class="rd-header__asset" *ngIf="project?.ProPakProject?.Asset?.Name">
        Asset: {{ project?.ProPakProject?.Asset?.Name }}
      </span>
    </div>
  </div>

  <div class="rd-header__right">
    <div class="rd-header__project-info" *ngIf="project?.ProPakProject?.Name">
      <span class="rd-header__project-label">Project</span>
      <span class="rd-header__project-name">{{ project?.ProPakProject?.Name }}</span>
    </div>

    <div *ngIf="showEditIconForUser" class="rd-header__edit-icon"
      [routerLink]="['/edit-project', project.ProPakProject.ProjectId]">
      <fa-icon [icon]="faPencil" size="lg" title="Edit Project"></fa-icon>
    </div>

    <span *ngIf="false" class="mr-2" style="font-weight: bold; font-size: 1em;">{{ timerService.timer$ | async }}</span>
    <div class="rd-header__client" *ngIf="project?.ProPakProject?.Client">
      <img height="28" [src]="clientLogo(project?.ProPakProject?.Client)" alt="">
      <span>{{ project?.ProPakProject?.Client?.Name }}</span>
    </div>
  </div>
</div>
</div>

<!-- ═══════ WARNING BANNER ═══════ -->
<div *ngIf="tasksWithUnsavedImages.size > 0" class="rd-warning">
  <fa-icon [icon]="faWarning" class="rd-warning__icon"></fa-icon>
  <div>
    <strong>Unsaved Image Uploads:</strong>
    <span>Image(s) uploaded for task(s) <strong>{{ Array.from(tasksWithUnsavedImages).join(', ') }}</strong> will not be associated with the task until you save the form.</span>
  </div>
</div>

<!-- ═══════ SUMMARY STATS BAR (single line) ═══════ -->
<div class="rd-stats">
  <div class="rd-stats__tabs">
    <div class="rd-tabs">
      <button class="rd-tab" [class.rd-tab--active]="selectedTaskType === 'current'" (click)="setTaskType('current')">
        CURRENT <strong>({{ currentCount }})</strong>
      </button>
      <button class="rd-tab" [class.rd-tab--active]="selectedTaskType === 'both'" (click)="setTaskType('both')">
        BOTH
      </button>
      <button class="rd-tab" [class.rd-tab--active]="selectedTaskType === 'archived'" (click)="setTaskType('archived')">
        ARCHIVED <strong>({{ archivedCount }})</strong>
      </button>
    </div>
  </div>

  <div class="rd-stats__search">
    <div class="rd-search">
      <fa-icon [icon]="faSearch" class="rd-search__icon"></fa-icon>
      <input type="text" class="rd-search__input" [(ngModel)]="readinessSearchText" (input)="onReadinessSearchChange()"
        placeholder="Search readiness..." title="Search across all task fields" />
    </div>
  </div>

  <div class="rd-stats__filters" *ngIf="isDisplayFilterButton || activeFilteredColumnsText">
    <button *ngIf="isDisplayFilterButton" class="rd-btn rd-btn--ghost rd-btn--sm" (click)="resetAllFilters()">Reset</button>
    <button type="button" class="rd-btn rd-btn--outline rd-btn--filters rd-btn--sm" (click)="resetAllFilters()" *ngIf="isDisplayFilterButton">
      <fa-icon [icon]="faFilter"></fa-icon>
    </button>
    <div *ngIf="activeFilteredColumnsText" class="rd-active-filters" [title]="activeFilteredColumnsText">
      <strong>Filters</strong>
    </div>
  </div>

  <div class="rd-stats__divider" aria-hidden="true"></div>

  <div class="rd-stats__total">
    <div class="rd-stats__total-icon">
      <fa-icon [icon]="faClipboardList"></fa-icon>
    </div>
    <div class="rd-stats__total-info">
      <span class="rd-stats__total-label">Total</span>
      <span class="rd-stats__total-number">{{ totalTasksForCurrentView }}</span>
      <span class="rd-stats__total-sub">{{ selectedTaskType === 'archived' ? 'Archived' : 'Current' }}</span>
    </div>
  </div>

  <div class="rd-stats__items">
    <div class="rd-stats__item">
      <span class="rd-stats__dot rd-stats__dot--green"></span>
      <span class="rd-stats__count">{{ completeCount }}</span>
      <span class="rd-stats__pct">({{ completePercent }}%)</span>
      <span class="rd-stats__item-label">Complete</span>
    </div>
    <div class="rd-stats__item">
      <span class="rd-stats__dot rd-stats__dot--orange"></span>
      <span class="rd-stats__count">{{ attentionCount }}</span>
      <span class="rd-stats__pct">({{ attentionPercent }}%)</span>
      <span class="rd-stats__item-label">Attention</span>
    </div>
    <div class="rd-stats__item">
      <span class="rd-stats__dot rd-stats__dot--red"></span>
      <span class="rd-stats__count">{{ blockedCount }}</span>
      <span class="rd-stats__pct">({{ blockedPercent }}%)</span>
      <span class="rd-stats__item-label">Blocked</span>
    </div>
  </div>

  <div class="rd-stats__progress">
    <span class="rd-stats__progress-label">Progress</span>
    <span class="rd-stats__progress-value">{{ overallProgress }}%</span>
    <div class="rd-stats__progress-bar">
      <div class="rd-stats__progress-fill" [style.width.%]="overallProgress"></div>
    </div>
  </div>
</div>

<!-- ═══════ ACTION TOOLBAR ═══════ -->
<div class="rd-actions">
  <div class="rd-actions__left">
    <a [href]="currentUrl" (click)="$event.preventDefault(); addNewTask(0)" *ngIf="isCurrentTaskSelected" title="Add New Task">
      <button class="rd-btn rd-btn--primary rd-btn--sm">
        <fa-icon [icon]="faPlusCircle"></fa-icon>
      </button>
    </a>
    <div class="propak-dropdown" [class.show]="showProPakDropdown" *ngIf="isRowSelected && selectedRows.length > 0">
      <button type="button" class="rd-btn rd-btn--primary rd-btn--sm propak-dropdown-btn" title="Open ProPak WorkPack"
        (click)="toggleProPakDropdown($event)" [attr.aria-expanded]="showProPakDropdown">
        <fa-icon [icon]="faWorkPackIcon"></fa-icon>
        <fa-icon [icon]="faChevronDown" class="propak-caret" size="xs"></fa-icon>
      </button>
      <div class="dropdown-menu propak-dropdown-menu" [class.show]="showProPakDropdown" role="menu">
        <button type="button" class="dropdown-item" role="menuitem" (click)="launchProPakFromDropdown()">
          <fa-icon [icon]="faWorkPackIcon" class="propak-option-icon" size="xs"></fa-icon>
          <span>ProPak</span>
        </button>
        <button type="button" class="dropdown-item" role="menuitem" (click)="launchAiAssistedProPak()">
          <span class="ai-sparkle-icon" aria-hidden="true" title="AI">
            <svg viewBox="0 0 24 24" width="16" height="16" focusable="false">
              <path fill="currentColor"
                d="M11.2 3.4c.2-.7 1.2-.7 1.4 0l1.15 4.05c.08.28.3.5.58.58L18.4 9.2c.7.2.7 1.2 0 1.4l-4.07 1.15c-.28.08-.5.3-.58.58L12.6 16.4c-.2.7-1.2.7-1.4 0l-1.15-4.07c-.08-.28-.3-.5-.58-.58L5.4 10.6c-.7-.2-.7-1.2 0-1.4l4.07-1.17c.28-.08.5-.3.58-.58L11.2 3.4z" />
              <path fill="currentColor"
                d="M18.35 2.55c.12-.4.68-.4.8 0l.45 1.55c.05.16.17.28.33.33l1.55.45c.4.12.4.68 0 .8l-1.55.45c-.16.05-.28.17-.33.33l-.45 1.55c-.12.4-.68.4-.8 0l-.45-1.55c-.05-.16-.17-.28-.33-.33l-1.55-.45c-.4-.12-.4-.68 0-.8l1.55-.45c.16-.05.28-.17.33-.33l.45-1.55z" />
              <rect x="3.2" y="16.9" width="3.4" height="1.5" rx="0.75" fill="currentColor" opacity="0.95" />
            </svg>
          </span>
          <span>New AI-Assisted ProPak</span>
        </button>
      </div>
    </div>
    <button class="rd-btn rd-btn--primary rd-btn--sm" (click)="undoChange()" title="Undo" *ngIf="canUndo()">
      <fa-icon [icon]="faUndo"></fa-icon>
    </button>
    <button class="rd-btn rd-btn--primary rd-btn--sm" (click)="redoChange()" title="Redo" *ngIf="canRedo()">
      <fa-icon [icon]="faRedo"></fa-icon>
    </button>
    <div *ngIf="isDisplayProPakWPToggle" class="rd-toggle-wrap">
      <label class="switch">
        <input type="checkbox" [(ngModel)]="isProPakWPEnable" (click)="toggleOnOff()">
        <span class="slider"></span>
      </label>
      <span class="rd-toggle-label">Show ProPak Work Packs</span>
    </div>

    <div class="rd-zoom" title="Zoom readiness form only">
      <span class="rd-zoom__label">Zoom</span>
      <button type="button" class="rd-zoom__btn" (click)="adjustFormZoom(-formZoomStep)"
        [disabled]="formZoomPercent <= formZoomMin" aria-label="Zoom out">
        <fa-icon [icon]="faMinus"></fa-icon>
      </button>
      <input type="range" class="rd-zoom__slider"
        [min]="formZoomMin" [max]="formZoomMax" [step]="formZoomStep"
        [ngModel]="formZoomPercent" (ngModelChange)="setFormZoom($event)"
        aria-label="Form zoom level" />
      <button type="button" class="rd-zoom__btn" (click)="adjustFormZoom(formZoomStep)"
        [disabled]="formZoomPercent >= formZoomMax" aria-label="Zoom in">
        <fa-icon [icon]="faPlus"></fa-icon>
      </button>
      <input type="text" inputmode="numeric" pattern="[0-9]*" class="rd-zoom__value"
        maxlength="3"
        [ngModel]="formZoomDraft"
        (ngModelChange)="onFormZoomDraftChange($event)"
        (focus)="formZoomDraft = formZoomPercent"
        (blur)="commitFormZoomDraft()"
        (keydown.enter)="$event.preventDefault(); commitFormZoomDraft()"
        aria-label="Form zoom percent" />
      <span class="rd-zoom__unit">%</span>
    </div>
  </div>

  <div class="rd-actions__right">
    <div *ngIf="activeCollaborators.length > 0" class="rd-collab">
      <strong>Also here:</strong>
      <span *ngFor="let user of activeCollaborators" class="avatar-circle avatar-circle--sm rd-collab__avatar"
        [attr.data-user-color]="userColorIndex(user)"
        [title]="user + ' is on this readiness form'">
        {{ user.charAt(0).toUpperCase() }}
      </span>
      <span *ngFor="let user of activeCollaborators; let last = last" class="rd-collab__name">
        {{ user }}<span *ngIf="!last">, </span>
      </span>
    </div>

    <div class="rd-autosave">
      <span class="rd-autosave__label">Auto Save</span>
      <label class="switch mb-0">
        <input type="checkbox" [(ngModel)]="autoSaveEnabled" (change)="onAutoSaveToggle()">
        <span class="slider"></span>
      </label>
      <span *ngIf="autoSaveEnabled" class="rd-autosave__countdown">
        <ng-container *ngIf="autoSaveInProgress">Saving…</ng-container>
        <ng-container *ngIf="!autoSaveInProgress">Auto saving in {{ autoSaveCountdownDisplay }}</ng-container>
      </span>
    </div>

    <button type="button" class="rd-btn rd-btn--primary rd-btn--sm" (click)="refreshReadinessDataOnly()" [disabled]="isLoading" title="Refresh Readiness Data">
      <fa-icon *ngIf="isLoading" [icon]="faSpinner" [spin]="true"></fa-icon>
      <fa-icon *ngIf="!isLoading" [icon]="faSync"></fa-icon>
      <span>Refresh</span>
    </button>

    <div class="export-dropdown" [class.show]="showExportDropdown">
      <button type="button" class="rd-btn rd-btn--primary rd-btn--sm export-dropdown-btn" (click)="toggleExportDropdown()" title="Export Readiness" [disabled]="exportInProgress !== null">
        <ng-container *ngIf="exportInProgress; else exportBtnIcon">
          <ng-container *ngTemplateOutlet="exportDownloadArrow; context: { variant: 'light' }"></ng-container>
        </ng-container>
        <ng-template #exportBtnIcon>
          <fa-icon [icon]="faFileExport"></fa-icon>
        </ng-template>
        <span>{{ exportInProgress ? 'Exporting...' : 'Export' }}</span>
      </button>
      <div class="dropdown-menu" [class.show]="showExportDropdown">
        <div class="dropdown-item export-pdf-option" (click)="$event.stopPropagation()">
          <label class="switch export-image-switch mb-0">
            <input type="checkbox" [(ngModel)]="includeTaskImages" />
            <span class="slider"></span>
          </label>
          <span class="export-pdf-option-label">
            <fa-icon [icon]="faImage" class="mr-1"></fa-icon>
            Include task images
          </span>
        </div>
        <div class="dropdown-item export-pdf-option" *ngIf="selectedTaskType === 'current' || selectedTaskType === 'archived'"
          (click)="$event.stopPropagation()">
          <label class="switch export-image-switch mb-0">
            <input type="checkbox" [(ngModel)]="exportIncludeOtherTaskType" />
            <span class="slider"></span>
          </label>
          <span class="export-pdf-option-label">
            {{ selectedTaskType === 'archived' ? 'Include Current Tasks' : 'Include Archive Tasks' }}
          </span>
        </div>
        <div class="dropdown-divider"></div>
        <button type="button" class="dropdown-item" (click)="exportReadinessReport('excel')" [disabled]="exportInProgress !== null">
          <ng-container *ngIf="exportInProgress === 'excel'; else excelIcon">
            <ng-container *ngTemplateOutlet="exportDownloadArrow; context: { variant: 'primary' }"></ng-container>
          </ng-container>
          <ng-template #excelIcon>
            <fa-icon [icon]="faFileExcel" class="mr-2"></fa-icon>
          </ng-template>
          {{ exportInProgress === 'excel' ? 'Exporting Excel...' : 'Export to Excel' }}
        </button>
        <button type="button" class="dropdown-item" (click)="exportReadinessReport('pdf')" [disabled]="exportInProgress !== null">
          <ng-container *ngIf="exportInProgress === 'pdf'; else pdfIcon">
            <ng-container *ngTemplateOutlet="exportDownloadArrow; context: { variant: 'primary' }"></ng-container>
          </ng-container>
          <ng-template #pdfIcon>
            <fa-icon [icon]="faFilePdf" class="mr-2"></fa-icon>
          </ng-template>
          {{ exportInProgress === 'pdf' ? 'Exporting PDF...' : 'Export to PDF' }}
        </button>
      </div>
    </div>

    <ng-template #exportDownloadArrow let-variant="variant">
      <span class="export-download-loader"
        [class.export-download-loader--light]="variant === 'light'"
        [class.export-download-loader--primary]="variant === 'primary'"
        [class.mr-2]="variant === 'primary'">
        <svg class="export-download-arrow" viewBox="0 0 24 32" aria-hidden="true" focusable="false">
          <path fill="currentColor"
            d="M11 2h2c1.1 0 2 .9 2 2v16.4l4.7-4.7a1.5 1.5 0 0 1 2.1 2.1l-7.5 7.5a1.5 1.5 0 0 1-2.1 0l-7.5-7.5a1.5 1.5 0 0 1 2.1-2.1l4.7 4.7V4c0-1.1.9-2 2-2z" />
        </svg>
      </span>
    </ng-template>

    <button type="button" class="rd-btn rd-btn--danger rd-btn--sm" *ngIf="isRowSelected" (click)="deleteSelectedRows()" title="Remove task(s)">
      <fa-icon [icon]="faTrash"></fa-icon>
    </button>
    <button type="button" class="rd-btn rd-btn--primary rd-btn--sm" (click)="saveAllTasks()">Save</button>
    <button type="button" class="rd-btn rd-btn--primary rd-btn--sm" *ngIf="showArchiveButton" (click)="archiveTask()">Archive</button>
    <button type="button" class="rd-btn rd-btn--primary rd-btn--sm" *ngIf="showUnarchiveButton" (click)="UnarchiveTasks()">Unarchive</button>
    <button type="button" class="rd-btn rd-btn--primary rd-btn--sm" *ngIf="isGroupingEnabled" (click)="removeGrouping()">Remove Grouping</button>
    <a *ngIf="showEditIconForUser" [routerLink]="['/readiness-admin-form', projectId]" title="Readiness Form Settings">
      <button class="rd-btn rd-btn--outline rd-btn--sm">
        <fa-icon [icon]="faCog"></fa-icon>
      </button>
    </a>
  </div>
</div>

<!-- Hidden file inputs -->
<input type="file" id="imageUploadInput" accept="image/*" (change)="onImageFileSelected($event)" style="display: none;" />
<input type="file" id="attachmentFileInput" multiple accept=".pdf,.xlsx,.csv,image/*" (change)="onAttachmentFilesSelected($event)" style="display: none;" />
<input type="file" id="taskImageFileInput" accept="image/*" (change)="onTaskImageFileSelected($event)" style="display: none;" />
<input type="file" id="attachmentFolderInput" webkitdirectory directory multiple accept=".pdf,.xlsx,.csv,image/*" (change)="onAttachmentFilesSelected($event)" style="display: none;" />
<input type="file" id="fileInput" (change)="onFileSelected($event)" style="display: none;" />

<div *ngIf="currentViewFilterStatusText" class="rd-filter-status">{{ currentViewFilterStatusText }}</div>

<!-- ═══════ MAIN TABLE (fixed pane — scrolls inside; zoom applies here only) ═══════ -->
<div class="rd-table-area" [style.zoom]="formZoomScale">
<div *ngFor="let form of formsList; let fi = index" class="rd-table-area__item">
  <div class="rd-table-wrap" [ngClass]="{'scroll-enabled': isAnySectionVisible, 'scroll-disabled': !isAnySectionVisible}" (scroll)="closeAllFilterDropdowns()">
        <table class="rd-table">
          <thead>
            <!-- Row 1: Section group headers (horizontal colored) -->
            <tr class="rd-thead-sections" [class.first-tr]="isSticky">
              <ng-container *ngFor="let section of groupedColumns; let i = index">
                <ng-container *ngIf="i == 0">
                  <th [attr.colspan]="section.columns.length+1" class="rd-thead-scope">
                    <div class="rd-scope-header">
                      <button (click)="togglePin()" class="rd-pin-btn" title="Fix left side of table">
                        <fa-icon [icon]="isSticky ? faPin : faPin"
                          [ngStyle]="isSticky ? {'transform': 'rotate(45deg)', 'color': '#10b981'} : {'color': '#9ca3af'}">
                        </fa-icon>
                      </button>
                      <div class="rd-scope-title">{{ this.project?.ProPakProject?.Name }}</div>
                      <a class="rd-help-link" title="Get help on Readiness Form" href="/readiness-guide" target="_blank" rel="noopener noreferrer">
                        <fa-icon [icon]="faHandsHelping" size="lg"></fa-icon>
                      </a>
                    </div>
                  </th>
                </ng-container>
                <th *ngIf="section.sectionName === 'Other'" [attr.colspan]="section.columns.length"></th>
                <th *ngIf="i !== 0 && section.sectionName !== 'Other'"
                  [attr.colspan]="sectionVisibility[section.sectionName] ? section.columns.length + 1 : 1"
                  class="rd-section-hdr"
                  [class.rd-section-hdr--collapsed]="!sectionVisibility[section.sectionName]"
                  [class.rd-section-hdr--expanded]="sectionVisibility[section.sectionName]"
                  (click)="toggleSection(section.sectionName)">
                  <ng-container *ngIf="!sectionVisibility[section.sectionName]">
                    <ng-container *ngFor="let user of getUsersBySection(section.sectionName)">
                      <span class="avatar-circle avatar-circle--sm" [attr.data-user-color]="userColorIndex(user)"
                        [title]="user + ' is working in this section'">
                        {{ user.charAt(0).toUpperCase() }}
                      </span>
                    </ng-container>
                  </ng-container>
                  <div class="rd-section-hdr__vertical custom-collapse-base collapse-float-right"
                    [class.rd-section-hdr__vertical--multiline]="isMultilineSectionHeader(section.sectionName)"
                    [ngClass]="formatClassName(section.sectionName)">
                    <span class="rd-section-hdr__line"
                      *ngFor="let line of getSectionDisplayLines(section.sectionName)">{{ line }}</span>
                  </div>
                </th>
              </ng-container>
            </tr>
            <!-- Row 2: Sub-headers (section full name when expanded) -->
            <tr [class.second-tr]="isSticky">
              <ng-container *ngFor="let section of groupedColumns; let i = index">
                <ng-container *ngIf="i == 0">
                  <th [attr.colspan]="section.columns.length+1" class="scope-of-work"></th>
                </ng-container>
                <th *ngIf="section.sectionName === 'Other'" [attr.colspan]="section.columns.length"></th>
                <th *ngIf="i !== 0 && section.sectionName !== 'Other'"
                  class="rd-section-subhdr"
                  [attr.colspan]="sectionVisibility[section.sectionName] ? section.columns.length : 1"
                  (click)="toggleSection(section.sectionName)"
                  [ngClass]="sectionVisibility[section.sectionName] ? formatRowClassName(section.sectionName) : ''">
                  <span class="rd-section-subhdr__title" *ngIf="sectionVisibility[section.sectionName]">
                    {{ getSectionText(section.sectionName) }}
                  </span>
                </th>
                <th *ngIf="i !== 0 && section.sectionName !== 'Other' && sectionVisibility[section.sectionName]"
                  class="rd-section-subhdr rd-section-subhdr--traffic"
                  (click)="toggleSection(section.sectionName)"
                  [ngClass]="formatRowClassName(section.sectionName)">
                </th>
              </ng-container>
            </tr>
            <!-- Row 3: Column headers -->
            <tr [class.third-tr]="isSticky">
              <th class="rd-checkbox-col">
                <input type="checkbox" [(ngModel)]="selectAll" title="Select All" (change)="toggleSelectAll()" class="readiness-checkbox" />
              </th>
              <ng-container *ngFor="let section of groupedColumns; let i = index">
                <ng-container *ngIf="sectionVisibility[section.sectionName]">
                  <ng-container *ngFor="let column of section.columns">
                    <th *ngIf="column.IsVisible" class="rd-col-header"
                      [ngClass]="{
                        'scope-of-work': i === 0,
                        'rd-col-header--status': column.ColumnName === 'Status',
                        'rd-col-header--task': column.ColumnName === 'TaskNumber'
                      }">
                      <div class="resizable-th">
                        <span (click)="sortAllRows(column.ColumnName)">{{ column.DisplayName }}</span>
                        <span *ngIf="globalSortColumn == column.ColumnName">
                          <fa-icon [icon]="globalSortOrder === 'asc' ? faArrowUp : faArrowDown" size="lg" style="color: #1e293b;"></fa-icon>
                        </span>
                        <span class="filter-icon" (click)="toggleFilterDropdown(column.ColumnName, column.DisplayName, $event)" style="cursor: pointer; float: right;">
                          <fa-icon [icon]="faFilter" size="lg" [style.color]="filteredColumns[column.ColumnName] ? '#2563eb' : '#9ca3af'"></fa-icon>
                        </span>
                        <span class="group-by-icon" (click)="sortAllRows(column.ColumnName)" style="cursor: pointer; display: none;">
                          <fa-icon [icon]="faSort" size="lg" style="color: gray;"></fa-icon>
                        </span>
                        <span class="group-by-icon" (click)="groupByColumn(column.ColumnName)" title="Group by column" style="float: right; cursor: pointer; display: none;">
                          <fa-icon [icon]="faLayerGroup" size="lg" style="color: gray;"></fa-icon>
                        </span>
                        <div class="resizer" title="Drag to resize, double-click to auto-fit" (mousedown)="onMouseDown($event)" (dblclick)="onResizerDoubleClick($event)"></div>
                      </div>
                    </th>
                  </ng-container>
                </ng-container>
                <th *ngIf="!sectionVisibility[section.sectionName]" class="rd-traffic-col-hdr"></th>
                <th *ngIf="sectionVisibility[section.sectionName] && i != 0 && section.sectionName != 'Other'" class="rd-traffic-col-hdr"></th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="100%">
                <div *ngFor="let _ of [1,2,3,4,5]">
                  <div class="skeleton-row" style="display: flex; gap: 5px;">
                    <div *ngFor="let __ of groupedColumns" class="skeleton-box" style="flex: 1; height: 30px; background: #e2e8f0; border-radius: 6px;"></div>
                  </div>
                  <br />
                </div>
              </td>
            </tr>

            <tr *ngIf="!isLoading && readinessLoadError">
              <td colspan="100%">
                <div class="rd-load-error" role="alert">
                  <fa-icon [icon]="faWarning"></fa-icon>
                  <div class="rd-load-error__text">
                    <strong>Readiness data could not be loaded</strong>
                    <div>{{ readinessLoadError }}</div>
                  </div>
                  <button type="button" class="rd-btn rd-btn--primary rd-btn--sm" (click)="retryLoadAllData()">
                    Try again
                  </button>
                </div>
              </td>
            </tr>

            <ng-container *ngIf="!isLoading && !readinessLoadError">
              <ng-container *ngIf="groupedByColumnValues && groupedByColumnValues.length > 0; else standardBody">
                <tr class="group-header stickyHeader" style="position: sticky;">
                  <td colspan="100%" class="text-bold" style="background-color: #f1f5f9;">
                    <b>Grouping by:</b>
                    <span *ngFor="let column of groupedByColumnValues; let i = index" class="rd-group-badge">
                      {{ column | titlecase }}
                      <span (click)="removeColumnFromGrouping(groupedByColumns[i])">
                        <fa-icon [icon]="faTimes" size="lg" style="color: white;"></fa-icon>
                      </span>
                    </span>
                  </td>
                </tr>
                <ng-container *ngFor="let group of groupedRows; let i = index">
                  <ng-container *ngIf="shouldDisplayGroup(group)">
                    <tr class="group-header">
                      <td colspan="100%" class="text-bold" style="background-color: #f1f5f9;">
                        <b>Group:</b> {{ group.groupKey }}
                      </td>
                    </tr>
                    <ng-container *ngIf="group.expanded">
                      <ng-container *ngFor="let row of group.rows; let j = index">
                        <tr *ngIf="row['EnableDisplay']"
                          [attr.draggable]="isCtrlPressed ? true : false" [id]="'row-' + j"
                          (dragstart)="onDragStart($event, i, j)" (dragover)="onDragOver($event)"
                          (drop)="onDrop($event, i, j)" (dragend)="onDragEnd()"
                          [ngClass]="{'rd-row--archived': row.ArchiveTaskId > 0 || row['IsArchived'] == true, 'highlight-duplicate': isDuplicateTaskRow(row)}">
                          <td class="rd-checkbox-cell">
                            <input type="checkbox" [(ngModel)]="row.IsSelected" class="readiness-checkbox"
                              *ngIf="row['EnableDisplay']" (ngModelChange)="ShowOrHideRemoveRowButton();" />
                          </td>
                          <ng-container *ngFor="let section of groupedColumns; let i = index">
                            <ng-container *ngIf="sectionVisibility[section.sectionName]">
                              <ng-container *ngFor="let column of section.columns">
                                <td *ngIf="column.IsVisible">
                                  <ng-container [ngSwitch]="column.ColumnType">
                                    <ng-container *ngSwitchCase="'VARCHAR'">
                                      <div *ngIf="isTaskNumberColumn(column)" class="rd-task-inline">
                                        <input type="text" [(ngModel)]="row[column.ColumnName]"
                                          [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                          (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                          class="form-control form-control-sm rd-task-inline__input" placeholder="Enter {{ column.DisplayName }}" />
                                        <div class="rd-task-inline__actions">
                                          <fa-icon [icon]="faFolderOpen" (click)="openAttachmentFolder(row)"
                                            [title]="getTaskAttachmentTitle(row)"
                                            class="rd-task-inline__icon rd-task-inline__icon--folder"></fa-icon>
                                          <fa-icon *ngIf="hasImage(row)" [icon]="faPencilAlt" (click)="editTaskImage(row)" title="Edit Image"
                                            class="rd-task-inline__icon rd-task-inline__icon--edit"></fa-icon>
                                          <fa-icon *ngIf="hasImage(row)" [icon]="faTrash" (click)="deleteImage(row)" title="Delete Image"
                                            class="rd-task-inline__icon rd-task-inline__icon--delete"
                                            [style.opacity]="isDeletingImage && deletingImageRowNumber === row.ActualRowNumber ? 0.5 : 1"
                                            [style.pointer-events]="isDeletingImage && deletingImageRowNumber === row.ActualRowNumber ? 'none' : 'auto'"></fa-icon>
                                          <fa-icon *ngIf="isDeletingImage && deletingImageRowNumber === row.ActualRowNumber" [icon]="faSpinner" [spin]="true"
                                            title="Deleting Image..." class="rd-task-inline__icon rd-task-inline__icon--spin"></fa-icon>
                                        </div>
                                        <button *ngIf="row._thumbnailUrl || row.ImageBlobUrl" type="button" class="rd-task-inline__thumb"
                                          (click)="showImagePopup(row)" title="Click to preview image">
                                          <img [src]="getSafeUrl(row._thumbnailUrl || row.ImageBlobUrl)" alt="Task image" />
                                        </button>
                                      </div>
                                      <input *ngIf="!isTaskNumberColumn(column)" type="text" [(ngModel)]="row[column.ColumnName]"
                                        [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                        (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                        class="form-control form-control-sm" placeholder="Enter {{ column.DisplayName }}" />
                                    </ng-container>
                                    <textarea *ngSwitchCase="'TEXTAREA'" type="text" [(ngModel)]="row[column.ColumnName]"
                                      [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                      (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                      class="form-control form-control-sm" placeholder="Enter {{ column.DisplayName }}"></textarea>
                                    <input *ngSwitchCase="'INTEGER'" type="number" [(ngModel)]="row[column.ColumnName]"
                                      [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                      (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                      class="form-control form-control-sm" placeholder="Enter {{ column.DisplayName }}" />
                                    <input *ngSwitchCase="'BOOLEAN'" type="checkbox" class="readiness-checkbox" [(ngModel)]="row[column.ColumnName]"
                                      [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                      (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);" />
                                    <select *ngSwitchCase="'DROPDOWN'" [(ngModel)]="row[column.ColumnName]"
                                      [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                      (ngModelChange)="onDropdownChange(column.ColumnName, $event, row, section.sectionName, false); calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                      class="form-control form-control-sm">
                                      <option *ngFor="let option of row._dropdownOptions[column.ColumnName]" [value]="option.Id">{{ option.Description }}</option>
                                    </select>
                                    <ng-container *ngIf="column.ColumnName === 'MaterialStatusId' && row.PIDAttachmentURL">
                                      <ng-container *ngIf="getPidAttachmentLinks(row.PIDAttachmentURL) as pidLinks">
                                        <ng-container *ngIf="pidLinks.length > 0">
                                          <span style="display: inline-block; margin-top: 4px; font-size: 12px;">
                                            <ng-container *ngFor="let link of pidLinks; let idx = index">
                                              <a [href]="link.href" target="_blank" rel="noopener noreferrer" (click)="onAttachmentClick($event, link.url)" style="cursor: pointer; color: #2563eb; text-decoration: underline;">{{ link.pidName }}</a>
                                              <span *ngIf="idx < pidLinks.length - 1">, </span>
                                            </ng-container>
                                          </span>
                                        </ng-container>
                                      </ng-container>
                                    </ng-container>
                                    <input *ngSwitchCase="'DATE'" type="date" [(ngModel)]="row[column.ColumnName]"
                                      [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                      (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                      class="form-control form-control-sm" />
                                    <input *ngSwitchDefault type="text" [(ngModel)]="row[column.ColumnName]"
                                      (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                      class="form-control form-control-sm" placeholder="Enter {{ column.DisplayName }}" />
                                  </ng-container>
                                </td>
                              </ng-container>
                            </ng-container>
                            <td class="rd-traffic-cell" *ngIf="i !== 0 && section.sectionName !== 'Other'">
                              <fa-icon [icon]="faCircle" size="lg" [ngStyle]="{'color': row[getSectionColorKey(section.sectionName)]}"></fa-icon>
                            </td>
                          </ng-container>
                          <div class="row-resizer" title="Drag to resize, double-click to auto-fit" (mousedown)="onRowMouseDown($event)" (dblclick)="onRowResizerDoubleClick($event)"></div>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>

              <ng-template #standardBody>
                <ng-container *ngFor="let row of readinessData.ReadinessFormData; let j = index;">
                  <tr *ngIf="row['EnableDisplay']" [id]="'row-' + j"
                    [ngClass]="{'rd-row--archived': row.ArchiveTaskId > 0 || row['IsArchived'] == true, 'body-sticky-td': isSticky, 'rd-row--new': row.IsNew, 'highlight-duplicate': isDuplicateTaskRow(row)}"
                    [attr.draggable]="isCtrlPressed || isGripActive ? true : false"
                    (dragstart)="onDragStart($event, fi, j)" (dragover)="onDragOver($event)"
                    (drop)="onDrop($event, fi, j)" (dragend)="onDragEnd()">
                    <td class="rd-checkbox-cell">
                      <input type="checkbox" [(ngModel)]="row.IsSelected" class="readiness-checkbox" (ngModelChange)="ShowOrHideRemoveRowButton();" />
                      <div class="drag-handle" title="Drag using this icon or hold Ctrl"
                        (mousedown)="onGripMouseDown($event)" (mouseup)="onGripMouseUp($event)"
                        [ngStyle]="{ cursor: isGripActive ? 'grabbing' : 'grab' }">
                        <fa-icon style="color: #94a3b8; font-size: 16px;" [icon]="faGripLinesVertical"></fa-icon>
                      </div>
                      <div class="plus-icon" (click)="addRowBelow(j)" *ngIf="isCurrentTaskSelected">
                        <fa-icon [icon]="faPlusCircle" title="Click to insert new task below."></fa-icon>
                      </div>
                    </td>
                    <ng-container *ngFor="let section of groupedColumns; let i = index">
                      <ng-container *ngIf="sectionVisibility[section.sectionName]">
                        <ng-container *ngFor="let column of section.columns">
                          <td *ngIf="column.IsVisible" style="position: relative;"
                            [id]="row.ActualRowNumber + '-' + column.ColumnName"
                            [class.rd-status-cell]="column.ColumnName === 'Status'"
                            [class.rd-task-cell]="column.ColumnName === 'TaskNumber'">
                            <ng-container [ngSwitch]="column.ColumnType">
                              <ng-container *ngIf="!(section.sectionName === 'Other' && column.ColumnName === 'Status')">
                                <ng-container *ngSwitchCase="'VARCHAR'">
                                  <div *ngIf="isTaskNumberColumn(column)" class="rd-task-inline">
                                    <input type="text" [(ngModel)]="row[column.ColumnName]"
                                      (focus)="onCellFocus(row.ActualRowNumber + '-' + column.ColumnName)"
                                      (blur)="onCellBlur(row.ActualRowNumber + '-' + column.ColumnName)"
                                      [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                      (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                      class="form-control form-control-sm rd-task-inline__input" placeholder="Enter {{ column.DisplayName }}" />
                                    <div class="rd-task-inline__actions">
                                      <fa-icon [icon]="faFolderOpen" (click)="openAttachmentFolder(row)"
                                        [title]="getTaskAttachmentTitle(row)"
                                        class="rd-task-inline__icon rd-task-inline__icon--folder"></fa-icon>
                                      <span *ngIf="showMultipleAttachments && hasAttachments(row)" class="rd-task-inline__count">{{ getAttachmentCount(row) }}</span>
                                      <fa-icon *ngIf="hasImage(row)" [icon]="faPencilAlt" (click)="editTaskImage(row)" title="Edit Image"
                                        class="rd-task-inline__icon rd-task-inline__icon--edit"></fa-icon>
                                      <fa-icon *ngIf="hasImage(row)" [icon]="faTrash" (click)="deleteImage(row)" title="Delete Image"
                                        class="rd-task-inline__icon rd-task-inline__icon--delete"
                                        [style.opacity]="isDeletingImage && deletingImageRowNumber === row.ActualRowNumber ? 0.5 : 1"
                                        [style.pointer-events]="isDeletingImage && deletingImageRowNumber === row.ActualRowNumber ? 'none' : 'auto'"></fa-icon>
                                      <fa-icon *ngIf="isDeletingImage && deletingImageRowNumber === row.ActualRowNumber" [icon]="faSpinner" [spin]="true"
                                        title="Deleting Image..." class="rd-task-inline__icon rd-task-inline__icon--spin"></fa-icon>
                                    </div>
                                    <button *ngIf="row._thumbnailUrl || row.ImageBlobUrl" type="button" class="rd-task-inline__thumb"
                                      (click)="showImagePopup(row)" title="Click to preview image">
                                      <img [src]="getSafeUrl(row._thumbnailUrl || row.ImageBlobUrl)" alt="Task image" />
                                    </button>
                                  </div>
                                  <input *ngIf="!isTaskNumberColumn(column)" type="text" [(ngModel)]="row[column.ColumnName]"
                                    (focus)="onCellFocus(row.ActualRowNumber + '-' + column.ColumnName)"
                                    (blur)="onCellBlur(row.ActualRowNumber + '-' + column.ColumnName)"
                                    [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                    (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                    class="form-control form-control-sm" placeholder="Enter {{ column.DisplayName }}" />
                                </ng-container>
                                <div class="editing-avatars" *ngIf="editingUsers[row.ActualRowNumber + '-' + column.ColumnName]?.length">
                                  <div *ngFor="let user of editingUsers[row.ActualRowNumber + '-' + column.ColumnName]" class="avatar-circle"
                                    [attr.data-user-color]="userColorIndex(user)" [title]="user + ' has currently selected this cell'">
                                    {{ user.charAt(0).toUpperCase() }}
                                  </div>
                                </div>
                                <textarea *ngSwitchCase="'TEXTAREA'" type="text" [(ngModel)]="row[column.ColumnName]"
                                  (focus)="onCellFocus(row.ActualRowNumber + '-' + column.ColumnName)"
                                  (blur)="onCellBlur(row.ActualRowNumber + '-' + column.ColumnName)"
                                  [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                  (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                  class="form-control form-control-sm" placeholder="Enter {{ column.DisplayName }}"></textarea>
                                <input *ngSwitchCase="'INTEGER'" type="number" [(ngModel)]="row[column.ColumnName]"
                                  (focus)="onCellFocus(row.ActualRowNumber + '-' + column.ColumnName)"
                                  (blur)="onCellBlur(row.ActualRowNumber + '-' + column.ColumnName)"
                                  [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                  (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);"
                                  class="form-control form-control-sm" placeholder="Enter {{ column.DisplayName }}" />
                                <input *ngSwitchCase="'BOOLEAN'" type="checkbox" [(ngModel)]="row[column.ColumnName]" class="readiness-checkbox"
                                  (focus)="onCellFocus(row.ActualRowNumber + '-' + column.ColumnName)"
                                  (blur)="onCellBlur(row.ActualRowNumber + '-' + column.ColumnName)"
                                  [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                  (ngModelChange)="calculateOverallStatus(row); onFieldChange(row.ActualRowNumber, column.ColumnName, $event);" />
                                <ng-container *ngIf="row && row._dropdownOptions && row._dropdownOptions[column.ColumnName]">
                                  <select *ngSwitchCase="'DROPDOWN'" [(ngModel)]="row[column.ColumnName]"
                                    (focus)="onCellFocus(row.ActualRowNumber + '-' + column.ColumnName)"
                                    (blur)="onCellBlur(row.ActualRowNumber + '-' + column.ColumnName)"
                                    [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                    (ngModelChange)="onFieldChange(row.ActualRowNumber, column.ColumnName, $event); onDropdownChange(column.ColumnName, $event, row, section.sectionName, false); calculateOverallStatus(row);"
                                    class="form-control form-control-sm">
                                    <option [value]="-1" disabled selected *ngIf="row[column.ColumnName] === -1 || row[column.ColumnName] === null">-- Select an option --</option>
                                    <option *ngFor="let option of row._dropdownOptions[column.ColumnName]" [value]="option.Id">{{ option.Description }}</option>
                                  </select>
                                  <ng-container *ngIf="column.ColumnName === 'MaterialStatusId' && row.PIDAttachmentURL">
                                    <ng-container *ngIf="getPidAttachmentLinks(row.PIDAttachmentURL) as pidLinks">
                                      <ng-container *ngIf="pidLinks.length > 0">
                                        <span style="display: inline-block; margin-top: 4px; font-size: 12px;">
                                          <ng-container *ngFor="let link of pidLinks; let idx = index">
                                            <a [href]="link.href" target="_blank" rel="noopener noreferrer" (click)="onAttachmentClick($event, link.url)" style="cursor: pointer; color: #2563eb; text-decoration: underline;">{{ link.pidName }}</a>
                                            <span *ngIf="idx < pidLinks.length - 1">, </span>
                                          </ng-container>
                                        </span>
                                      </ng-container>
                                    </ng-container>
                                  </ng-container>
                                </ng-container>
                                <input *ngSwitchCase="'DATE'" type="date" [(ngModel)]="row[column.ColumnName]"
                                  (focus)="onCellFocus(row.ActualRowNumber + '-' + column.ColumnName)"
                                  (blur)="onCellBlur(row.ActualRowNumber + '-' + column.ColumnName)"
                                  [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                  (ngModelChange)="onFieldChange(row.ActualRowNumber, column.ColumnName, $event); calculateOverallStatus(row)"
                                  class="form-control form-control-sm" />
                                <input *ngSwitchDefault type="text" [(ngModel)]="row[column.ColumnName]"
                                  (focus)="onCellFocus(row.ActualRowNumber + '-' + column.ColumnName)"
                                  (blur)="onCellBlur(row.ActualRowNumber + '-' + column.ColumnName)"
                                  [ngClass]="{'border-danger': showValidationErrors && isInvalid(row, column), 'highlight-changed': isFieldHighlightChanged(row.ActualRowNumber, column.ColumnName)}" [attr.data-remote-user]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.colorIndex" [attr.title]="remoteChangedCells[row.ActualRowNumber + '-' + column.ColumnName]?.tooltip"
                                  (ngModelChange)="onFieldChange(row.ActualRowNumber, column.ColumnName, $event); calculateOverallStatus(row)"
                                  class="form-control form-control-sm" placeholder="Enter {{ column.DisplayName }}" />
                              </ng-container>
                              <ng-container *ngIf="section.sectionName === 'Other' && column.ColumnName === 'Status'">
                                <div class="rd-status-ring" [style.--rd-pct]="getStatusPercentValue(row.Status)">
                                  <svg viewBox="0 0 36 36" class="rd-status-ring__svg" aria-hidden="true">
                                    <path class="rd-status-ring__bg" pathLength="100"
                                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                    <path class="rd-status-ring__fill" pathLength="100"
                                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                  </svg>
                                  <span class="rd-status-ring__text">{{ row.Status }}</span>
                                </div>
                              </ng-container>
                            </ng-container>
                          </td>
                        </ng-container>
                      </ng-container>
                      <td class="rd-traffic-cell" *ngIf="i !== 0 && section.sectionName !== 'Other'">
                        <fa-icon [icon]="faCircle" size="lg" [ngStyle]="{'color': row[getSectionColorKey(section.sectionName)]}"></fa-icon>
                      </td>
                    </ng-container>
                    <div class="row-resizer" title="Drag to resize, double-click to auto-fit" (mousedown)="onRowMouseDown($event)" (dblclick)="onRowResizerDoubleClick($event)"></div>
                  </tr>
                </ng-container>
              </ng-template>
            </ng-container>
          </tbody>
        </table>
        <div *ngIf="form.rows.length === 0;" class="rd-empty">
          <p>{{ form.noDataMessage }}</p>
        </div>
  </div>
</div>
</div>

<!-- ═══════ IMAGE PREVIEW POPUP ═══════ -->
<div *ngIf="showImagePreview" class="image-preview-popup" [style.left.px]="imagePreviewPosition.x"
  [style.top.px]="imagePreviewPosition.y"
  style="position: fixed; background: white; border: 2px solid #333; border-radius: 8px; padding: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.3); z-index: 10000; min-width: 300px; max-width: 600px;">
  <div (mousedown)="startDraggingImage($event)"
    style="cursor: move; background: #f0f0f0; padding: 8px; margin: -10px -10px 10px -10px; border-radius: 6px 6px 0 0; display: flex; justify-content: space-between; align-items: center;">
    <span style="font-weight: bold; font-size: 14px;">Image Preview for {{selectedImageRow.TaskNumber}} </span>
    <div style="display: flex; gap: 10px; align-items: center;">
      <button *ngIf="tempImageBase64" (click)="saveImage()" class="btn btn-primary btn-sm" title="Select Image"
        [disabled]="isUploadingImage" style="display: flex; align-items: center; gap: 5px; margin-right: 5px;">
        <fa-icon *ngIf="!isUploadingImage" [icon]="faUpload" style="color: white !important"></fa-icon>
        <fa-icon *ngIf="isUploadingImage" [icon]="faSpinner" [spin]="true" style="color: white !important"></fa-icon>
        <span>{{ isUploadingImage ? 'Selecting...' : 'Select' }}</span>
      </button>
      <fa-icon *ngIf="selectedImageRow" [icon]="faPencilAlt" (click)="editTaskImage(selectedImageRow)" title="Edit Image" style="cursor: pointer; color: #ffc107; font-size: 18px;"></fa-icon>
      <fa-icon *ngIf="selectedImageRow && hasImage(selectedImageRow) && !tempImageBase64" [icon]="faTrash" (click)="deleteImage(selectedImageRow)" title="Delete Image"
        style="cursor: pointer; color: #dc3545; font-size: 18px;"
        [style.opacity]="isDeletingImage ? 0.5 : 1" [style.pointer-events]="isDeletingImage ? 'none' : 'auto'"></fa-icon>
      <fa-icon *ngIf="isDeletingImage" [icon]="faSpinner" [spin]="true" title="Deleting Image..." style="color: #0082CA; font-size: 18px;"></fa-icon>
      <fa-icon [icon]="faTimes" (click)="closeImagePreview()" title="Close" style="cursor: pointer; color: #dc3545; font-size: 20px;"></fa-icon>
    </div>
  </div>
  <div style="text-align: center; max-height: 500px; overflow: auto; min-height: 250px; display: flex; align-items: center; justify-content: center; background: #f9f9f9; position: relative;">
    <img *ngIf="imagePreviewUrl" [src]="getSafeUrl(imagePreviewUrl)" alt="Task Image" (load)="onImageLoad()" (error)="onImageError()"
      style="max-width: 100%; max-height: 100%; width: auto; height: auto; border-radius: 4px; border: 1px solid #ddd; object-fit: contain; padding: 10px; display: flex;" />
    <div *ngIf="!imagePreviewUrl && !isUploadingImage && !imageLoadFailed" style="color: #999; text-align: center;">
      <div style="margin-bottom: 10px;">No image available</div>
    </div>
    <div *ngIf="imageLoadFailed" style="color: #dc3545; text-align: center;">
      <div style="margin-bottom: 10px;">Failed to load image</div>
      <small style="color: #999;">Click the edit icon to upload a new image</small>
    </div>
  </div>
</div>

<!-- ═══════ ATTACHMENT MODAL ═══════ -->
<div *ngIf="showAttachmentModal" class="attachment-modal-backdrop">
  <div class="attachment-modal-dialog" (click)="$event.stopPropagation()">
    <div class="attachment-modal-content">
      <div class="attachment-modal-header">
        <h5 class="attachment-modal-title">
          <fa-icon [icon]="faFolderOpen" class="mr-2"></fa-icon>
          Attachments – Task {{ selectedAttachmentRow?.TaskNumber }}
        </h5>
        <button type="button" class="attachment-modal-close" (click)="closeAttachmentModal()" aria-label="Close">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
      <div class="attachment-modal-body">
        <div class="attachment-section">
          <h6 class="attachment-section-title mb-2">
            <fa-icon [icon]="faImage" class="mr-1"></fa-icon> Task Image
          </h6>
          <ng-container *ngIf="hasTaskImage()">
            <div style="margin-bottom: 8px;">
              <span class="small text-muted d-block mb-1">
                Current Task Image
                <span *ngIf="getTaskImageSource()" class="badge ml-1"
                  [ngClass]="{'badge-info': getTaskImageSource() === 'ProPak', 'badge-secondary': getTaskImageSource() === 'ClientDash'}"
                  style="font-size: 10px; vertical-align: middle;">
                  {{ getTaskImageSource() === 'ProPak' ? 'Source: ProPak' : 'Source: ClientDash' }}
                </span>
              </span>
              <div style="margin-bottom: 8px;">
                <img *ngIf="getTaskImageUrl()" [src]="getSafeUrl(getTaskImageUrl())" alt="Task image"
                  style="max-width: 200px; max-height: 140px; border-radius: 4px; border: 1px solid #ccc; object-fit: cover; cursor: pointer;"
                  (click)="previewTaskImageInPopup()" title="Click to preview full size" />
              </div>
              <div class="task-image-actions">
                <button type="button" class="btn btn-task-image-edit btn-sm" (click)="triggerTaskImageUpload()" title="Replace with a new image">
                  <fa-icon [icon]="faPencilAlt" class="mr-1"></fa-icon> Replace
                </button>
                <button type="button" class="btn btn-task-image-remove btn-sm" (click)="removeTaskImage()" title="Remove this image">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon> Remove
                </button>
              </div>
              <p class="text-muted small mt-2 mb-0">Replace to upload a new image, or remove to choose from ProPak / your PC.</p>
            </div>
          </ng-container>
          <ng-container *ngIf="!hasTaskImage()">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
              <span><fa-icon [icon]="faWorkPackIcon" class="mr-1"></fa-icon> Get image from ProPak</span>
              <label class="attachment-toggle-label mb-0">
                <input type="checkbox" [(ngModel)]="fetchProPakImage" (ngModelChange)="onProPakToggleChange()" />
                <span class="attachment-toggle-slider"></span>
              </label>
            </div>
            <div *ngIf="fetchProPakImage">
              <div *ngIf="isLoadingWorkPackReference" class="attachment-loader-block">
                <fa-icon [icon]="faSpinner" [spin]="true" class="attachment-spinner"></fa-icon>
                <span class="attachment-loader-text">Fetching from ProPak…</span>
              </div>
              <div *ngIf="!isLoadingWorkPackReference && workPackTaskReference && workPackTaskReference.taskImageUrl" class="workpack-reference-card">
                <div class="workpack-reference-meta">
                  <span *ngIf="workPackTaskReference.workPackNumber" class="workpack-meta-item">Work Pack: <strong>{{ workPackTaskReference.workPackNumber }}</strong></span>
                  <span *ngIf="workPackTaskReference.taskNumber" class="workpack-meta-item">Task: <strong>{{ workPackTaskReference.taskNumber }}</strong></span>
                </div>
                <div class="workpack-image-wrap">
                  <span class="small text-muted d-block mb-1">Task image from Work Pack</span>
                  <div class="workpack-image-container">
                    <div *ngIf="!workPackTaskImageLoaded && !workPackTaskImageError" class="attachment-image-loader attachment-image-loader-overlay">
                      <fa-icon [icon]="faSpinner" [spin]="true" class="attachment-spinner"></fa-icon>
                      <span class="attachment-loader-text">Loading image…</span>
                    </div>
                    <img [src]="getSafeUrl(workPackTaskReference.taskImageUrl)" alt="Task reference" class="workpack-reference-img" (load)="onWorkPackTaskImageLoad()" (error)="onWorkPackTaskImageError()" />
                    <div *ngIf="workPackTaskImageError" class="attachment-image-error attachment-image-error-overlay">
                      <fa-icon [icon]="faImage" class="mb-1"></fa-icon>
                      <span>Image could not be loaded</span>
                    </div>
                  </div>
                  <div style="display: flex; gap: 8px; margin-top: 8px;">
                    <button type="button" class="btn btn-primary btn-sm" (click)="addProPakImageAsTaskImage()" title="Set as task image">
                      <fa-icon [icon]="faImage" class="mr-1"></fa-icon> Set as Task Image
                    </button>
                    <button *ngIf="showMultipleAttachments" type="button" class="btn btn-outline-primary btn-sm" (click)="addProPakImageToAttachments()" title="Add as regular attachment">
                      <fa-icon [icon]="faPlusCircle" class="mr-1"></fa-icon> Add to Attachments
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="!isLoadingWorkPackReference && (!workPackTaskReference || !workPackTaskReference?.taskImageUrl) && selectedAttachmentRow?.TaskNumber" class="text-muted small">No Work Pack image for this task.</div>
            </div>
            <div *ngIf="!fetchProPakImage" style="margin-top: 8px;">
              <div class="task-image-dropzone" [ngClass]="{'dragover': isDragOverTaskImageZone}"
                (dragenter)="onDragEnterTaskImageZone($event)" (dragover)="onDragOverTaskImageZone($event)"
                (dragleave)="onDragLeaveTaskImageZone($event)" (drop)="onDropTaskImageZone($event)">
                <div class="dropzone-content" style="text-align: center;">
                  <fa-icon [icon]="faUpload" class="dropzone-icon"></fa-icon>
                  <p class="dropzone-text">Drag and drop image here or click button below</p>
                  <small class="dropzone-subtext">PNG, JPG, JPEG, GIF, WEBP</small>
                </div>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="triggerTaskImageUpload()" style="margin-top: 8px;">
                <fa-icon [icon]="faUpload" class="mr-1"></fa-icon> Upload Task Image
              </button>
              <p class="text-muted small mt-1 mb-0">Select an image from your PC to set as the task image.</p>
            </div>
          </ng-container>
        </div>
        <div *ngIf="showMultipleAttachments" class="attachment-section attachment-list-section">
          <h6 class="attachment-section-title">
            <fa-icon [icon]="faFile" class="mr-1"></fa-icon> Attachments
          </h6>
          <div *ngIf="isLoadingAttachments" class="attachment-loader-block">
            <fa-icon [icon]="faSpinner" [spin]="true" class="attachment-spinner"></fa-icon>
            <span class="attachment-loader-text">Loading attachments…</span>
          </div>
          <ng-container *ngIf="!isLoadingAttachments">
            <div class="attachment-actions">
              <button type="button" class="btn btn-primary btn-sm btn-files" (click)="triggerAttachmentFileInput()" [disabled]="isUploadingAttachment">
                <fa-icon [icon]="faUpload" class="mr-1"></fa-icon> Add files
              </button>
            </div>
            <p class="attachment-accept-hint">Accepted: images, PDF, XLSX, CSV. Upload happens when you click Save.</p>
            <div class="attachment-dropzone" [ngClass]="{'dragover': isDragOverAttachmentZone}"
              (dragenter)="onDragEnterAttachmentZone($event)" (dragover)="onDragOverAttachmentZone($event)"
              (dragleave)="onDragLeaveAttachmentZone($event)" (drop)="onDropAttachmentZone($event)">
              <div *ngIf="attachmentList.length === 0" class="attachment-empty-hint">
                <div class="dropzone-content">
                  <fa-icon [icon]="faUpload" class="dropzone-icon"></fa-icon>
                  <p class="dropzone-text">Drag and drop files here or click "Add files" above</p>
                  <small class="dropzone-subtext">Images, PDF, XLSX, CSV</small>
                </div>
              </div>
              <div *ngIf="attachmentList.length > 0" class="dropzone-hint">Drag files here to add more</div>
            </div>
            <div class="attachment-list-scroll">
              <div class="attachment-list">
                <div *ngFor="let att of attachmentList; let i = index" class="attachment-item">
                  <div class="attachment-item-preview" (click)="getAttachmentOpenUrl(att) && openAttachment(att)">
                    <fa-icon *ngIf="!isPreviewableFile(att.fileType)" [icon]="getAttachmentIcon(att)" class="attachment-file-icon" [ngClass]="getAttachmentIconClass(att)"></fa-icon>
                    <div *ngIf="isPreviewableFile(att.fileType)" class="attachment-thumb-wrap">
                      <div *ngIf="att.loading" class="attachment-image-loader attachment-image-loader-overlay">
                        <fa-icon [icon]="faSpinner" [spin]="true" class="attachment-spinner"></fa-icon>
                      </div>
                      <img *ngIf="getAttachmentOpenUrl(att)" [src]="getSafeUrl(getAttachmentOpenUrl(att))" alt="" class="attachment-thumb" (load)="onAttachmentThumbnailLoad(i)" (error)="onAttachmentThumbnailError(i)" />
                      <div *ngIf="att.loadError" class="attachment-image-error attachment-image-error-overlay attachment-thumb">
                        <fa-icon [icon]="faImage"></fa-icon>
                      </div>
                    </div>
                  </div>
                  <div class="attachment-item-info">
                    <span class="attachment-item-name" [title]="att.fileName" (click)="getAttachmentOpenUrl(att) && openAttachment(att)">{{ att.fileName }}</span>
                    <span *ngIf="att.isTaskImage" class="badge" style="background-color: #2563eb; color: white; font-size: 10px; padding: 2px 6px; border-radius: 3px; margin-left: 4px;">Task Image</span>
                    <span *ngIf="att.source" class="badge" [style.background-color]="att.source === 'ProPak' ? '#0ea5e9' : '#6b7280'" style="color: white; font-size: 10px; padding: 2px 6px; border-radius: 3px; margin-left: 4px;">{{ att.source === 'ProPak' ? 'ProPak' : 'ClientDash' }}</span>
                    <a *ngIf="getAttachmentOpenUrl(att)" href="javascript:void(0)" class="attachment-item-open" (click)="openAttachment(att)">Open</a>
                  </div>
                  <button type="button" class="attachment-item-remove" (click)="removeAttachment(i); $event.stopPropagation()" title="Delete attachment">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="attachment-modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAttachmentModal()" [disabled]="isUploadingAttachment">Cancel</button>
        <button type="button" class="btn btn-primary btn-save" (click)="saveAttachmentsToRow()" [disabled]="isUploadingAttachment">
          <fa-icon *ngIf="!isUploadingAttachment" [icon]="faSave" class="mr-1"></fa-icon>
          <fa-icon *ngIf="isUploadingAttachment" [icon]="faSpinner" [spin]="true" class="mr-1"></fa-icon>
          {{ isUploadingAttachment ? 'Saving…' : 'Save' }}
        </button>
      </div>
    </div>
    <!-- PDF Preview Modal -->
    <div *ngIf="showPdfPreview" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.7); display: flex; justify-content: center; align-items: center; z-index: 9999;" (click)="closePdfPreview()">
      <div style="background: white; border-radius: 8px; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3); width: 90%; height: 90%; max-width: 1200px; display: flex; flex-direction: column; overflow: hidden;" (click)="$event.stopPropagation()">
        <div style="padding: 16px; border-bottom: 1px solid #e0e0e0; display: flex; justify-content: space-between; align-items: center; background-color: #f5f5f5;">
          <div><h5 style="margin: 0; color: #333; font-weight: 600;">{{ pdfFileName }}</h5></div>
          <div style="display: flex; gap: 10px;">
            <a [href]="pdfPreviewUrl" target="_blank" rel="noopener noreferrer" download style="padding: 8px 16px; background-color: #2563eb; color: white; border-radius: 4px; text-decoration: none; font-size: 14px; cursor: pointer;">Download</a>
            <button (click)="closePdfPreview()" style="padding: 8px 16px; background-color: #6b7280; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">Close</button>
          </div>
        </div>
        <div style="flex: 1; overflow: auto; background: #f0f0f0;">
          <iframe [src]="getSafePdfUrl(pdfPreviewUrl)" style="width: 100%; height: 100%; border: none;"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="filter-dropdown filter-dropdown--overlay"
  *ngIf="openFilterColumn"
  [ngStyle]="filterDropdownStyle"
  (click)="$event.stopPropagation()">
  <div class="filter-search-container">
    <input type="text" class="filter-search-input"
      [(ngModel)]="filterSearchText[openFilterColumn.name]"
      placeholder="Search filter..." />
  </div>
  <div class="filter-options-container">
    <div class="filter-option filter-select-all">
      <label class="filter-label">
        <input type="checkbox"
          [checked]="isAllFilterOptionsSelected(openFilterColumn.name)"
          (change)="onSelectAllFilterChange(openFilterColumn.name, $event.target.checked)">
        <span class="filter-text"><strong>Select All</strong></span>
      </label>
    </div>
    <div class="filter-option" *ngFor="let option of getFilteredDropdownOptions(openFilterColumn.name)">
      <label class="filter-label">
        <input type="checkbox"
          [checked]="isOptionSelected(openFilterColumn.name, option.Id)"
          (change)="onFilterChange(openFilterColumn.name, option.Id, $event.target.checked)">
        <span class="filter-text">{{ option.Description }}</span>
        <span class="filter-archived-badge" *ngIf="option.IsArchivedOnly"
          title="This value only exists on archived tasks">Archived</span>
      </label>
    </div>
  </div>
  <div class="filter-actions">
    <button class="btn-apply" (click)="applyFilter(openFilterColumn.name, openFilterColumn.displayName)">Apply</button>
    <button class="btn-clear" (click)="clearFilter(openFilterColumn.name, openFilterColumn.displayName)">Clear</button>
  </div>
</div>
